export default __webpack_public_path__ + "static/media/hover2.ea058b43.jpg";